module.exports = __webpack_public_path__ + "assets/e22e29f9e63b2fe25b246f2ba07b4676.png";